// extracted by mini-css-extract-plugin
module.exports = {"navbar":"LoginNavbar_navbar__20gO8","logo":"LoginNavbar_logo__fdAlk"};